module.exports = "/assets/images/search_4718ed.svg";